/** @format */

import { request } from 'src/utils'

// 策略列表
export const getPrometheusAlertPolicyList = async (params?) => {
  const result = await request('/monitor/?Action=ListPrometheusAlertPolicies&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}
// 删除策略
export const deletePrometheusAlertPolicy = async (params?) => {
  const result = await request('/monitor/?Action=DeletePrometheusAlertPolicy&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 删除规则
export const deletePrometheusAlertRule = async (params?) => {
  const result = await request('/monitor/?Action=DeletePrometheusAlertRule&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 修改规则状态
export const updatePrometheusAlertRuleState = async (params?) => {
  const result = await request('/monitor/?Action=UpdateAlertRuleState&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 修改策略下规则状态
export const updatePrometheusAlertPolicyRuleState = async (params?) => {
  const result = await request(
    '/monitor/?Action=UpdatePrometheusAlertPolicyState&Version=2025-01-01',
    {
      data: params || {},
      method: 'POST'
    }
  )
  return result
}

// 创建策略
export const createPrometheusAlertPolicy = async (params?) => {
  const result = await request('/monitor/?Action=CreatePrometheusAlertPolicy&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 更新策略
export const updatePrometheusAlertPolicy = async (params?) => {
  const result = await request('/monitor/?Action=UpdatePrometheusAlertPolicy&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}

// 模板列表
export const getPrometheusAlertTemplateList = async (params?) => {
  const result = await request('/monitor/?Action=ListPrometheusAlertTemplates&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 模板详情
export const getPrometheusAlertTemplate = async (params?) => {
  const result = await request('/monitor/?Action=GetPrometheusAlertTemplate&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 创建模板
export const createPrometheusAlertTemplate = async (params?) => {
  const result = await request(
    '/monitor/?Action=CreatePrometheusAlertPolicyTemplate&Version=2025-01-01',
    {
      data: params || {},
      method: 'POST'
    }
  )
  return result
}

// 更新模板
export const updatePrometheusAlertTemplate = async (params?) => {
  const result = await request(
    '/monitor/?Action=UpdatePrometheusAlertPolicyTemplate&Version=2025-01-01',
    {
      data: params || {},
      method: 'POST'
    }
  )
  return result
}

// 删除模板
export const deletePrometheusAlertTemplate = async (params?) => {
  const result = await request(
    '/monitor/?Action=DeletePrometheusAlertPolicyTemplate&Version=2025-01-01',
    {
      data: params || {},
      method: 'DELETE'
    }
  )
  return result
}

// YAML校验
export const validateAlertRule = async (params?) => {
  const result = await request('/monitor/?Action=ValidateAlertRule&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result?.data
}

// 告警中列表
export const getPrometheusAlerting = async (params?) => {
  const result = await request('/monitor/?Action=ListPrometheusAlerts&Version=2025-01-01', {
    data: params || {},
    method: 'GET'
  })
  return result?.data
}

// 通知列表
export const getPrometheusAlertNotific = async (params?) => {
  const result = await request(
    '/monitor/?Action=ListPrometheusAlertNotificationRecords&Version=2025-01-01',
    {
      data: params || {},
      method: 'GET'
    }
  )
  return result?.data
}
